import script from "./ow-expenses-form.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-expenses-form.vue?vue&type=script&setup=true&lang=js"

import "./ow-expenses-form.vue?vue&type=style&index=0&id=1b5b1912&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b5b1912"]])

export default __exports__